import { AppMode, ProductKeys } from '@logz-pkg/enums';
import { ISidenavItemConfig } from '../../Sidenav/item-configs';
import { ExtendedLogos } from 'ui/components/shared/Logo/Logo';
import { dashboardsHubRouteName } from 'states/dashboards-hub/dashboards-hub.routes';
import { spmRouteNames } from 'states/spm.routes';
import { alertsRoutesStates } from 'states/alerts.routes';

export const rootNavItems: ISidenavItemConfig[] = [
  {
    fixedSidenavText: 'Logs',
    expandedSidenavTitle: 'Log Management',
    key: ProductKeys.Explore,
    mode: AppMode.OPERATIONS,
    logo: ExtendedLogos.ExploreNew,
    targetStateName: 'dashboard.explore',
    expandedNavGroups: [],
  },
  {
    fixedSidenavText: 'Dashboards',
    mode: AppMode.OPERATIONS,
    expandedSidenavTitle: 'Dashboards Hub',
    key: ProductKeys.DashboardsHub,
    logo: ExtendedLogos.DashboardsHub,
    targetStateName: dashboardsHubRouteName,
    expandedNavGroups: [],
  },
  {
    key: ProductKeys.App360,
    fixedSidenavText: 'APM',
    expandedSidenavTitle: 'App 360',
    targetStateName: spmRouteNames.servicesTable,
    mode: AppMode.OPERATIONS,
    logo: ExtendedLogos.App360,
    expandedNavGroups: [],
  },
  {
    fixedSidenavText: 'Infra',
    mode: AppMode.OPERATIONS,
    expandedSidenavTitle: 'K8S 360',
    key: ProductKeys.K8S360,
    logo: ExtendedLogos.K8S360,
    targetStateName: 'dashboard.k8s360',
    expandedNavGroups: [],
  },
  {
    fixedSidenavText: 'Alerts',
    mode: AppMode.OPERATIONS,
    expandedSidenavTitle: 'Alerts definitions',
    key: ProductKeys.Alerts,
    logo: ExtendedLogos.Alerts,
    targetStateName: alertsRoutesStates.alertDefinition,
    expandedNavGroups: [],
  },
];
